export class TipoNfe {
    public static VENDA = 1;
    public static DEVOLUCAO = 3;
    public static COBRANCA = 4;
    public static COBRANCA_V2 = 5;
    public static REMESSA_ENTRADA_PARA_INDUSTRIALIZACAO = 6;
    public static REMESSA_INDUSTRIALIZACAO_CONTA_ORDEM = 7;
    public static DESPACHO_PEDIDO = 14;
    public static NOTA_COMPRA_PARA_REVENDA = 16;
    public static LANCAMENTO_EFETUADO_TITULO_BAIXA_ESTOQUE = 18;
    public static VENDA_ORIGINADA_ENCOMENDA_FUTURA = 24;
    public static OUTRAS_SAIDAS = 25;
    public static NFE_COMPLEMENTAR = 28;
    public static VENDA_A_ORDEM = 30; // 5120/6120
    public static RETORNO_REMESSA_ATIVO_IMOBILIZADO = 31; // 5554/6554
    public static IMPORTACAO = 34; // 3101/3102/3551/3949
    public static NF_REMESSA_RETORNO_MERCADORIA_EXPOSICAO_FEIRA = 35;
    public static EXPORTACAO = 36; // 7XXX
    public static NOTA_FILHA = 37;
    public static NOTA_SAIDA_IMPORTACAO = 38;
    public static TRANSFERENCIA_MATERIAL_USO_CONSUMO = 39; // 5557/6557
    public static NOTA_DEVOLUCAO_VENDA = 40;
    public static REMESSA_COM_FIM_EXPORTACAO = 41; // (5501, 6501, 5502, 6502) Remessa com fim específico de exportação
    public static ENTRADA_DE_MERCADORIA_COM_FIM_EXPORTACAO = 42; // (1501, 2501) Entrada de mercadoria recebida com fim específico de exportação
}
